var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4799_7999)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.3774 2.43355L17.5651 0.621049C16.737 -0.207036 15.3897 -0.206997 14.5616 0.621049C13.782 1.40077 1.87359 13.3101 1.07777 14.1059C0.993003 14.1907 0.936206 14.3034 0.915971 14.4136L0.00980134 19.3073C-0.0253158 19.497 0.0351529 19.6919 0.171598 19.8284C0.308199 19.965 0.503121 20.0253 0.692613 19.9902L5.58592 19.0839C5.69901 19.0628 5.81018 19.0055 5.89354 18.9221L19.3774 5.43717C20.2074 4.60717 20.2075 3.26366 19.3774 2.43355ZM1.31722 18.6826L1.86538 15.7223L4.27733 18.1344L1.31722 18.6826ZM5.47924 17.6791L2.3207 14.5203L13.8523 2.9878L17.0109 6.14658L5.47924 17.6791ZM18.5488 4.60854L17.8395 5.31795L14.6809 2.15917L15.3902 1.44976C15.7614 1.07859 16.3652 1.07855 16.7365 1.44976L18.5488 3.26225C18.9209 3.63432 18.9209 4.23643 18.5488 4.60854Z",
    fill: "#D2042D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4799_7999"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.d93a48605da52abead569ae3251bb516.svg";
export { ForwardRef as ReactComponent };